import * as React from 'react';
import LoginForm from './LoginForm'
import { Button, Typography } from '@material-ui/core';

class MyAccount extends React.Component<any> {

  public render() {
    const login: boolean = this.props.login;
   // const linkBasket : string = process.env.PUBLIC_URL + "/basket";
    const MyLinkBasket = (props: any) => <a href={process.env.PUBLIC_URL + "/basket"} {...props}/>;

    if (!login) {
      return (
        <div className="Login">
          <LoginForm checkLogin={this.props.checkLogin} />
        </div>
      );
    } else {
      return (
        <div>
          <Typography color="primary" align="center" variant="h2">
            My Account
          </Typography>
          <p> Hello {this.props.customer.firstName}, You are logged in </p>
          <Button
            variant="contained"
            color="primary"
            onClick={() => this.props.actionLogout()}
            className="Buttons"
          >
            Log out
          </Button>
          <Button
            variant="contained"
            color="secondary"
            component = {MyLinkBasket}
            onClick={() => this.props.actionUpdate()}
            className="Buttons"
          >
            Basket
          </Button>

        </div>
      );
    }
  }
}
export default MyAccount;


// WEBPACK FOOTER //
// ./src/components/myaccount/MyAccount.tsx